import React from 'react';
import PropTypes from 'prop-types';
import { putRequest } from '../../../../requestUtils';
import './InterviewMeetingDetails.scss';

class InterviewMeetingDetails extends React.Component {
  constructor(props) {
    super(props);

    const defaultMeetingDetails = this.props.meetingDetails || '';

    this.state = {
      meetingDetails: defaultMeetingDetails,
      displayedMeetingDetails: defaultMeetingDetails,
      isEditing: false,
    };

    this.handleEditMeetingLink = this.handleEditMeetingLink.bind(this);
    this.handleSubmitMeeting = this.handleSubmitMeeting.bind(this);
  }

  handleEditMeetingLink() {
    this.setState({ isEditing: true });
  }

  handleSubmitMeeting() {
    const { csrfToken, editInterviewPath, onSubmit } = this.props;
    const { meetingDetails, displayedMeetingDetails } = this.state;

    if (meetingDetails === displayedMeetingDetails) {
      this.setState({ isEditing: false });
      return;
    }

    const params = { interview: { meeting_details: meetingDetails }, project_permissions: {} };

    putRequest(editInterviewPath, params, csrfToken).then((response) => {
      onSubmit(response);
      this.setState({ isEditing: false, displayedMeetingDetails: meetingDetails });
    });
  }

  renderMeetingLink() {
    const { displayedMeetingDetails } = this.state;

    if (displayedMeetingDetails) {
      return (
        <div className="body-text-2 medium-weight">
          Meeting room details:
          <br />
          <div
            className="body-text-2 normal-weight text-prewrap mt-4"
          >
            {displayedMeetingDetails}
          </div>
        </div>
      );
    }

    return (
      <div className="body-text-2 normal-weight">
        Clora will post the details here when the meeting room is set up.
      </div>
    );
  }

  renderMeetingLinkInput() {
    const { isEditing, meetingDetails } = this.state;

    const ctaCopy = meetingDetails ? 'Edit meeting details' : '+ Add meeting details';

    if (!isEditing) {
      return (
        <a
          className="edit-meeting-link-cta medium-weight body-text-2"
          role="button"
          tabIndex="0"
          onClick={this.handleEditMeetingLink}
        >
          {ctaCopy}
        </a>
      );
    }

    return (
      <div className="meeting-link-input">
        <textarea
          value={meetingDetails}
          rows="4"
          onChange={(e) => this.setState({ meetingDetails: e.target.value })}
          id="meeting-link"
          name="meeting-link"
        />
        <a
          onClick={this.handleSubmitMeeting}
          role="button"
          tabIndex="0"
          className="btn btn-primary small submit-meeting-link mt-3"
        >
          Submit
        </a>
      </div>
    );
  }

  render() {
    const { isRep } = this.props;
    const { isEditing } = this.state;

    return (
      <div className="interview-meeting-details style-guide">
        { isRep
          && (
          <div className="meeting-link-input-container mb-8">
            {this.renderMeetingLinkInput()}
          </div>
          )}
        {!isEditing && this.renderMeetingLink()}
      </div>
    );
  }
}

InterviewMeetingDetails.propTypes = {
  meetingDetails: PropTypes.string,
  editInterviewPath: PropTypes.string.isRequired,
  csrfToken: PropTypes.string.isRequired,
  isRep: PropTypes.bool,
  onSubmit: PropTypes.func,
};

InterviewMeetingDetails.defaultProps = {
  meetingDetails: null,
  isRep: false,
  onSubmit: () => null,
};

export default InterviewMeetingDetails;
